var _style, _rect, _line, _polygon, _circle, _polyline, _defs, _defs2, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreetingPageAbstractShapesWide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000178889669609723220510000007695203486957718451_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2153.3 1059",
    style: {
      enableBackground: "new 0 0 2153.3 1059"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01BFA5;}\n\t.st1{fill:#1DE9B6;}\n\t.st2{fill:#212950;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st4{clip-path:url(#SVGID_00000134208319177933934910000018141643209602670516_);fill:#64FFDA;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000139997195593942840710000005905850494736769693_);fill:none;stroke:#212950;stroke-width:4;stroke-miterlimit:10;}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000088821081989572488080000003812000262159454628_);fill:none;stroke:#64FFDA;stroke-width:4;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 2153.3,
    height: 1059
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1845.7,
    y1: 1059,
    x2: 439.7,
    y2: 1059
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2153.3,529.5 2153.3,1059 0,1059 0,692.6 147.3,474.9 439.7,605 607.7,506 1230.7,724 1624.7,509  1845.7,604 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1250.7,
    cy: 545,
    r: 376
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "0,784.7 318.1,618.9 1029.2,797.5 1122.2,720.5 1223.2,846.5 1399.2,495.5 1555.2,681.5 1845.7,457  2153.3,651.8 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 1250.7,
    cy: 545,
    r: 376
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068677404947705859770000015560428802019751300_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000068677404947705859770000015560428802019751300_)",
      fill: "#64FFDA"
    },
    points: "868.7,612  1114.7,350 1381.7,644 1646.7,497 1637.7,955 875.1,955  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000031179367609520732820000004445219276169578387_",
    cx: 1250.7,
    cy: 545,
    r: 376
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116199021748025695840000007166943842685055883_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031179367609520732820000004445219276169578387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000116199021748025695840000007166943842685055883_)",
      fill: "none",
      stroke: "#212950",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    points: " 242.2,601.5 1029.2,797.5 1122.2,720.5 1223.2,846.5 1399.2,495.5 1555.2,681.5 1900.2,414.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000086670137048823408070000014360555982802651028_",
    points: "1177.7,420 1381.3,643.2 1614.7,514.5  1403.7,337  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052071267816048603540000018324549199883136647_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086670137048823408070000014360555982802651028_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000052071267816048603540000018324549199883136647_)",
      fill: "none",
      stroke: "#64FFDA",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    points: " 242.2,601.5 1029.2,797.5 1122.2,720.5 1223.2,846.5 1399.2,495.5 1555.2,681.5 1900.2,414.5  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreetingPageAbstractShapesWide);
export default __webpack_public_path__ + "static/media/greeting_page_abstract_shapes_wide.6adc40aa26310d2e06cc167afe9f7f6d.svg";
export { ForwardRef as ReactComponent };